import { render } from "./TalentDetail.vue?vue&type=template&id=ef681bba&scoped=true"
import script from "./TalentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentDetail.vue?vue&type=script&setup=true&lang=js"

import "./TalentDetail.vue?vue&type=style&index=0&id=ef681bba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef681bba"],['__file',"src/views/recruitment/talent/TalentDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef681bba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef681bba', __exports__)) {
    console.log('reload')
    api.reload('ef681bba', __exports__)
  }
  
  module.hot.accept("./TalentDetail.vue?vue&type=template&id=ef681bba&scoped=true", () => {
    console.log('re-render')
    api.rerender('ef681bba', render)
  })

}


export default __exports__